import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab from 'eco-design/elements/eco-tab';
import { useState } from 'react';

const MultiLayered: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('MultiLayered');

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751253719219/1-pad.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751253719219/1-pad.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751253718198/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751253718626/2-pad.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751253718407/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751253718993/3-pad.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },

        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751253719355/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751253718800/4-pad.jpg',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className={styles.MultiLayered}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="multi-layered-box page-layout">
                <div className="multi-layered-box-img">
                    <EcoImg pc={list[activeIndex].pc} pad={list[activeIndex].pad} />
                </div>
                <EcoTab
                    activeKey="item1"
                    items={list.map((item, index) => ({
                        tabLabel: item.title,
                        tabValue: `item${index + 1}`,
                    }))}
                    onChange={(item, index) => {
                        setActiveIndex(index);
                    }}
                />
                <div className="footer-desc">{list[activeIndex].desc}</div>
            </div>
        </div>
    );
};

export default MultiLayered;
